module.exports = __webpack_public_path__ + "img/img_fuchuang@2x.39cfe0e0.png";